import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { StateRowCount } from '../../../models/state-row-count.model'
import { environment } from '../../../environments/environments';

@Injectable({
  providedIn: 'root'
})
export class StateCountService {
  constructor(private http: HttpClient) {}

  /**
   * Calls GET /api/tables/{tableName}/state-counts and returns the
   * list of 16 Bundesländer + TOTAL as an Observable.
   */
  getStateCounts(tableName: string): Observable<StateRowCount[]> {
    const url = `${environment.apiUrl}/tables/${tableName}/state-counts`;
    console.log(url);
    return this.http.get<StateRowCount[]>(url).pipe(
        catchError(this.handleError)
    );
  }

  // you can swap this for any global interceptor you already have
  private handleError(err: HttpErrorResponse) {
    console.error('State-count request failed', err);
    return throwError(() =>
        new Error(err.error?.message || 'State-count request failed.'));
  }

}
